import { css } from 'styled-components'

const transparentCriticalButtonTemplate = () => css`
  color: var(--sl-fg-critical);
  background: transparent;

  height: auto;
  padding: 0.125rem 0.25rem;

  svg {
    color: var(--sl-fg-critical);
  }

  &:not(:disabled) {
    &:hover {
      color: var(--sl-fg-critical-hover);
    }
  }

  &:disabled {
    color: var(--sl-fg-base-disabled);
  }
`

export default transparentCriticalButtonTemplate
